import { Box, IconButton } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

const marquee = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const PlayerPanel = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: 32,
  right: 64,
  zIndex: theme.zIndex.modal + 1,
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "14px 20px 14px 16px",
  backgroundColor: theme.palette.system[0],
  borderRadius: 1000,
  boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.12)",
  border: "1px solid rgba(117, 131, 247, 0.22)",
  width: 400,
}));

export const PlayPauseButtonWrapper = styled(Box)(() => ({
  position: "relative",
  width: 52,
  height: 52,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ProgressRing = styled("svg")(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: 52,
  height: 52,
  transform: "rotate(-90deg)",
  pointerEvents: "none",
  zIndex: 1,
}));

export const ProgressTrack = styled("circle")(({ theme }) => ({
  fill: "none",
  stroke: theme.palette.secondary[400],
  strokeWidth: 2.4,
  opacity: 0.3,
}));

export const ProgressCircle = styled("circle")(({ theme }) => ({
  fill: "none",
  stroke: theme.palette.secondary[500],
  strokeWidth: 2.4,
  strokeLinecap: "round",
}));

// Inner button is 42x42, centered in the 52x52 wrapper (5px gap for the ring)
export const PlayPauseButton = styled(IconButton)(({ theme }) => ({
  width: 42,
  height: 42,
  backgroundColor: theme.palette.secondary[500],
  position: "relative",
  zIndex: 0,
  "&:hover": {
    backgroundColor: theme.palette.secondary[600],
  },
}));

export const ContentContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
  flex: 1,
  minWidth: 0,
}));

export const TextContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 2,
  flex: 1,
  minWidth: 0,
}));

export const MainTextWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isLoading" && prop !== "shouldScroll",
})(({ isLoading, shouldScroll }) => ({
  overflow: "hidden",
  width: "100%",
  ...(!isLoading && shouldScroll && {
    maskImage: "linear-gradient(to right, transparent 0px, black 12px, black calc(100% - 12px), transparent 100%)",
    WebkitMaskImage: "linear-gradient(to right, transparent 0px, black 12px, black calc(100% - 12px), transparent 100%)",
  }),
}));

export const MainText = styled(Box, {
  shouldForwardProp: (prop) => prop !== "shouldScroll",
})(({ theme, shouldScroll }) => ({
  ...theme.typography.body2,
  color: theme.palette.text[800],
  whiteSpace: "nowrap",
  display: "inline-block",
  ...(shouldScroll && {
    animation: `${marquee} 25s linear infinite`,
    paddingRight: 40,
  }),
}));

export const CaptionText = styled(Box)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.grey[600],
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  cursor: "default",
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  width: 20,
  height: 20,
  padding: 0,
  flexShrink: 0,
  color: theme.palette.text[700],
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.palette.text[800],
  },
}));
